/**
 * Subscription Management Platform API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.3
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import {HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse} from '@angular/common/http';
import {CustomHttpUrlEncodingCodec} from '../encoder';

import {Observable} from 'rxjs/Observable';

import {CARDGROUPINFO} from '../model/cARDGROUPINFO';
import {CARDINFO} from '../model/cARDINFO';
import {RESPONSEITEM} from '../model/rESPONSEITEM';
import {OPERATIONINFO} from '../model/oPERATIONINFO';

import {POOLINFO} from '../model/pOOLINFO';
import {SMDPPROFILE} from '../model/sMDPPROFILE';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {
  ACLINFO,
  AUDITTRAILINFO, PoolObjectSubset,
  SMSRDESTINATIONADDRESSOBJECT,
  SMSRHTTPADDRESSOBJECT,
  SUBSCRIPTIONINFO,
  TRANSACTIONINFO,
  APIOPERATIONINFO,
  UPDATECONNECTIVITYOBJECT,
  USERINFO
} from "..";

@Injectable()
export class DefaultService {

  protected basePath = 'https://localhost';
  public defaultHeaders = new HttpHeaders();
  public configuration = new Configuration();

  constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (let consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }
  /**
   *
   * Get cards of a card group
   * @param cardGroupId Id of requested card group
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardGroupsCardGroupIdCardsGet(cardGroupId: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CARDINFO>>;
  public cardGroupsCardGroupIdCardsGet(cardGroupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CARDINFO>>>;
  public cardGroupsCardGroupIdCardsGet(cardGroupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CARDINFO>>>;
  public cardGroupsCardGroupIdCardsGet(cardGroupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (cardGroupId === null || cardGroupId === undefined) {
      throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdCardsGet.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<CARDINFO>>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/cards`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Move cards to the selected group
   * @param cardGroupId ID of the target card group
   * @param eids The list containing EIDs of cards to be assigned to the target card group
   * @param sourceId ID of the source card group containing cards to be moved
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardGroupsCardGroupIdCardsPut(cardGroupId: number, eids: Array<string>, sourceId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<RESPONSEITEM>>;
  public cardGroupsCardGroupIdCardsPut(cardGroupId: number, eids: Array<string>, sourceId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RESPONSEITEM>>>;
  public cardGroupsCardGroupIdCardsPut(cardGroupId: number, eids: Array<string>, sourceId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RESPONSEITEM>>>;
  public cardGroupsCardGroupIdCardsPut(cardGroupId: number, eids: Array<string>, sourceId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (cardGroupId === null || cardGroupId === undefined) {
      throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdCardsPut.');
    }
    if (eids === null || eids === undefined) {
      throw new Error('Required parameter eids was null or undefined when calling cardGroupsCardGroupIdCardsPut.');
    }
    if (sourceId === null || sourceId === undefined) {
      throw new Error('Required parameter sourceId was null or undefined when calling cardGroupsCardGroupIdCardsPut.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (sourceId !== undefined) {
      queryParameters = queryParameters.set('source_id', <any>sourceId);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.put<Array<RESPONSEITEM>>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}/cards`,
      eids,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Delete a card group from the database
   * @param cardGroupId Id of requested card group
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardGroupsCardGroupIdDelete(cardGroupId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public cardGroupsCardGroupIdDelete(cardGroupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public cardGroupsCardGroupIdDelete(cardGroupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public cardGroupsCardGroupIdDelete(cardGroupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (cardGroupId === null || cardGroupId === undefined) {
      throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdDelete.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.delete<any>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get information about the card group
   * @param cardGroupId Id of requested card group
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardGroupsCardGroupIdGet(cardGroupId: string, observe?: 'body', reportProgress?: boolean): Observable<CARDGROUPINFO>;
  public cardGroupsCardGroupIdGet(cardGroupId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CARDGROUPINFO>>;
  public cardGroupsCardGroupIdGet(cardGroupId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CARDGROUPINFO>>;
  public cardGroupsCardGroupIdGet(cardGroupId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (cardGroupId === null || cardGroupId === undefined) {
      throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdGet.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<CARDGROUPINFO>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Update a card group
   * @param cardGroupId Id of card group to update
   * @param cardGroupObject New card group information
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardGroupsCardGroupIdPost(cardGroupId: string, cardGroupObject: CARDGROUPINFO, observe?: 'body', reportProgress?: boolean): Observable<CARDGROUPINFO>;
  public cardGroupsCardGroupIdPost(cardGroupId: string, cardGroupObject: CARDGROUPINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CARDGROUPINFO>>;
  public cardGroupsCardGroupIdPost(cardGroupId: string, cardGroupObject: CARDGROUPINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CARDGROUPINFO>>;
  public cardGroupsCardGroupIdPost(cardGroupId: string, cardGroupObject: CARDGROUPINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (cardGroupId === null || cardGroupId === undefined) {
      throw new Error('Required parameter cardGroupId was null or undefined when calling cardGroupsCardGroupIdPost.');
    }
    if (cardGroupObject === null || cardGroupObject === undefined) {
      throw new Error('Required parameter cardGroupObject was null or undefined when calling cardGroupsCardGroupIdPost.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.post<CARDGROUPINFO>(`${this.basePath}/card_groups/${encodeURIComponent(String(cardGroupId))}`,
      cardGroupObject,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Card group list getting operation. This is the operation to get a list of card groups managed by the authenticated account
   * @param offset An offset for a list (required for pagination)
   * @param limit A maximum number of entries returned by the request
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardGroupsGet(offset?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<CARDGROUPINFO>>;
  public cardGroupsGet(offset?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CARDGROUPINFO>>>;
  public cardGroupsGet(offset?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CARDGROUPINFO>>>;
  public cardGroupsGet(offset?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<CARDGROUPINFO>>(`${this.basePath}/card_groups`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Number of card groups getting operation. This is the operation to get a number of card groups managed by the authenticated account
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardGroupsHead(observe?: 'body', reportProgress?: boolean): Observable<any>;
  public cardGroupsHead(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public cardGroupsHead(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public cardGroupsHead(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.head<any>(`${this.basePath}/card_groups`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Register new card group in the database. Account should be granted with special permissions for this procedure
   * @param cardGroupObject
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardGroupsPut(cardGroupObject: CARDGROUPINFO, observe?: 'body', reportProgress?: boolean): Observable<CARDGROUPINFO>;
  public cardGroupsPut(cardGroupObject: CARDGROUPINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CARDGROUPINFO>>;
  public cardGroupsPut(cardGroupObject: CARDGROUPINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CARDGROUPINFO>>;
  public cardGroupsPut(cardGroupObject: CARDGROUPINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (cardGroupObject === null || cardGroupObject === undefined) {
      throw new Error('Required parameter cardGroupObject was null or undefined when calling cardGroupsPut.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.put<CARDGROUPINFO>(`${this.basePath}/card_groups`,
      cardGroupObject,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get list of available audit trail records for the card
   * @param eid EID of a requested card
   * @param offset offset within last events
   * @param limit maximum number of entries to be returned
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidAuditGet(eid: string, offset?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<AUDITTRAILINFO>>;
  public cardsEidAuditGet(eid: string, offset?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<AUDITTRAILINFO>>>;
  public cardsEidAuditGet(eid: string, offset?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<AUDITTRAILINFO>>>;
  public cardsEidAuditGet(eid: string, offset?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidAuditGet.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<AUDITTRAILINFO>>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/audit`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Number of available audit trail records for the card
   * @param eid EID of a requested card
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidAuditHead(eid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public cardsEidAuditHead(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public cardsEidAuditHead(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public cardsEidAuditHead(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidAuditHead.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.head<any>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/audit`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Request online card audit operation for all profiles on this card
   * @param eid EID of a requested card
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidAuditPost(eid: string, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidAuditPost(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidAuditPost(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidAuditPost(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidAuditPost.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/audit`,
      null,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get detailed information on the operation related to particular audit trail record
   * @param eid EID of a requested card
   * @param recordId Record identifier within the euicc audit trail
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidAuditRecordIdGet(eid: string, recordId: number, observe?: 'body', reportProgress?: boolean): Observable<APIOPERATIONINFO>;
  public cardsEidAuditRecordIdGet(eid: string, recordId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APIOPERATIONINFO>>;
  public cardsEidAuditRecordIdGet(eid: string, recordId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APIOPERATIONINFO>>;
  public cardsEidAuditRecordIdGet(eid: string, recordId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
      if (eid === null || eid === undefined) {
          throw new Error('Required parameter eid was null or undefined when calling cardsEidAuditRecordIdGet.');
      }
      if (recordId === null || recordId === undefined) {
          throw new Error('Required parameter recordId was null or undefined when calling cardsEidAuditRecordIdGet.');
      }

      let headers = this.defaultHeaders;

      // authentication (basicAuth) required
      if (this.configuration.username || this.configuration.password) {
          headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
      }

      // to determine the Accept header
      let httpHeaderAccepts: string[] = [
          'application/json'
      ];
      let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      if (httpHeaderAcceptSelected != undefined) {
          headers = headers.set("Accept", httpHeaderAcceptSelected);
      }

      // to determine the Content-Type header
      let consumes: string[] = [
      ];

      return this.httpClient.get<APIOPERATIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/audit/${encodeURIComponent(String(recordId))}`,
          {
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
  }

  /**
   *
   * Get a profile with the fallback attribute
   * @param eid EID of the requested card
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidFallbackGet(eid: string, observe?: 'body', reportProgress?: boolean): Observable<SUBSCRIPTIONINFO>;
  public cardsEidFallbackGet(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SUBSCRIPTIONINFO>>;
  public cardsEidFallbackGet(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SUBSCRIPTIONINFO>>;
  public cardsEidFallbackGet(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidFallbackGet.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<SUBSCRIPTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/fallback`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Set fallback attribute operation
   * @param eid EID of the requested card
   * @param iccid ICCID of the target profile
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidFallbackPost(eid: string, iccid: string, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidFallbackPost(eid: string, iccid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidFallbackPost(eid: string, iccid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidFallbackPost(eid: string, iccid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
      if (eid === null || eid === undefined) {
          throw new Error('Required parameter eid was null or undefined when calling cardsEidFallbackPost.');
      }
      if (iccid === null || iccid === undefined) {
          throw new Error('Required parameter iccid was null or undefined when calling cardsEidFallbackPost.');
      }

      let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
      if (iccid !== undefined) {
          queryParameters = queryParameters.set('iccid', <any>iccid);
      }

      let headers = this.defaultHeaders;

      // authentication (basicAuth) required
      if (this.configuration.username || this.configuration.password) {
          headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
      }

      // to determine the Accept header
      let httpHeaderAccepts: string[] = [
          'application/json'
      ];
      let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      if (httpHeaderAcceptSelected != undefined) {
          headers = headers.set("Accept", httpHeaderAcceptSelected);
      }

      // to determine the Content-Type header
      let consumes: string[] = [
      ];

      return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/fallback`,
          null,
          {
              params: queryParameters,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
  }

  /**
   *
   * Delete a card from the database
   * @param eidOrIccid EID or ICCID of a requested card
   * @param poolReturnProfileFlag Profiles returns into pool, if flag is true
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidOrIccidDelete(eidOrIccid: string, poolReturnProfileFlag?: boolean, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public cardsEidOrIccidDelete(eidOrIccid: string, poolReturnProfileFlag?: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public cardsEidOrIccidDelete(eidOrIccid: string, poolReturnProfileFlag?: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public cardsEidOrIccidDelete(eidOrIccid: string, poolReturnProfileFlag?: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eidOrIccid === null || eidOrIccid === undefined) {
      throw new Error('Required parameter eidOrIccid was null or undefined when calling cardsEidOrIccidDelete.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (poolReturnProfileFlag !== undefined) {
      queryParameters = queryParameters.set('poolReturnProfileFlag', <any>poolReturnProfileFlag);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.delete<any>(`${this.basePath}/cards/${encodeURIComponent(String(eidOrIccid))}`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get detailed information about the card
   * @param eidOrIccid EID or ICCID of a requested card
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidOrIccidGet(eidOrIccid: string, observe?: 'body', reportProgress?: boolean): Observable<CARDINFO>;
  public cardsEidOrIccidGet(eidOrIccid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CARDINFO>>;
  public cardsEidOrIccidGet(eidOrIccid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CARDINFO>>;
  public cardsEidOrIccidGet(eidOrIccid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eidOrIccid === null || eidOrIccid === undefined) {
      throw new Error('Required parameter eidOrIccid was null or undefined when calling cardsEidOrIccidGet.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<CARDINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eidOrIccid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Delete a profile from the card
   * @param eid EID of a requested card
   * @param iccid ICCID of a target profile
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidProfilesDelete(eid: string, iccid: string, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidProfilesDelete(eid: string, iccid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidProfilesDelete(eid: string, iccid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidProfilesDelete(eid: string, iccid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesDelete.');
    }
    if (iccid === null || iccid === undefined) {
      throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesDelete.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (iccid !== undefined) {
      queryParameters = queryParameters.set('iccid', <any>iccid);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.delete<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get a list of profiles available on the card
   * @param eid EID of a requested card
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidProfilesGet(eid: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SUBSCRIPTIONINFO>>;
  public cardsEidProfilesGet(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SUBSCRIPTIONINFO>>>;
  public cardsEidProfilesGet(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SUBSCRIPTIONINFO>>>;
  public cardsEidProfilesGet(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesGet.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<SUBSCRIPTIONINFO>>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Request online card audit operation for single profiles on this card
   * @param eid EID of the requested card
   * @param iccid ICCID of the requested card
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidProfilesIccidAuditPost(eid: string, iccid: string, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidProfilesIccidAuditPost(eid: string, iccid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidProfilesIccidAuditPost(eid: string, iccid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidProfilesIccidAuditPost(eid: string, iccid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesIccidAuditPost.');
    }
    if (iccid === null || iccid === undefined) {
      throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesIccidAuditPost.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles/${encodeURIComponent(String(iccid))}/audit`,
      null,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Update connectivity parameters for given ICCID; will return transaction id to check status of operation
   * @param eid EID of the requested card
   * @param iccid ICCID of the requested card
   * @param connectivityObject Connectivity configuration
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidProfilesIccidConnectivityPost(eid: string, iccid: string, connectivityObject: UPDATECONNECTIVITYOBJECT, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidProfilesIccidConnectivityPost(eid: string, iccid: string, connectivityObject: UPDATECONNECTIVITYOBJECT, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidProfilesIccidConnectivityPost(eid: string, iccid: string, connectivityObject: UPDATECONNECTIVITYOBJECT, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidProfilesIccidConnectivityPost(eid: string, iccid: string, connectivityObject: UPDATECONNECTIVITYOBJECT, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesIccidConnectivityPost.');
    }
    if (iccid === null || iccid === undefined) {
      throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesIccidConnectivityPost.');
    }
    if (connectivityObject === null || connectivityObject === undefined) {
      throw new Error('Required parameter connectivityObject was null or undefined when calling cardsEidProfilesIccidConnectivityPost.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles/${encodeURIComponent(String(iccid))}/connectivity`,
      connectivityObject,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Update SM-SR destination address for given ICCID; will return transaction id to check status of operation
   * @param eid EID of the requested card
   * @param iccid ICCID of the requested card
   * @param smsrAddressObject SM-SR address configuration
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidProfilesIccidSmsrDestinationAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRDESTINATIONADDRESSOBJECT, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidProfilesIccidSmsrDestinationAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRDESTINATIONADDRESSOBJECT, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidProfilesIccidSmsrDestinationAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRDESTINATIONADDRESSOBJECT, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidProfilesIccidSmsrDestinationAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRDESTINATIONADDRESSOBJECT, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesIccidSmsrDestinationAddressPost.');
    }
    if (iccid === null || iccid === undefined) {
      throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesIccidSmsrDestinationAddressPost.');
    }
    if (smsrAddressObject === null || smsrAddressObject === undefined) {
      throw new Error('Required parameter smsrAddressObject was null or undefined when calling cardsEidProfilesIccidSmsrDestinationAddressPost.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles/${encodeURIComponent(String(iccid))}/smsr_destination_address`,
      smsrAddressObject,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Update SM-SR HTTP address for given ICCID; will return transaction id to check status of operation
   * @param eid EID of the requested card
   * @param iccid ICCID of the requested card
   * @param smsrAddressObject SM-SR address configuration
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidProfilesIccidSmsrHttpAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRHTTPADDRESSOBJECT, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidProfilesIccidSmsrHttpAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRHTTPADDRESSOBJECT, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidProfilesIccidSmsrHttpAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRHTTPADDRESSOBJECT, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidProfilesIccidSmsrHttpAddressPost(eid: string, iccid: string, smsrAddressObject: SMSRHTTPADDRESSOBJECT, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesIccidSmsrHttpAddressPost.');
    }
    if (iccid === null || iccid === undefined) {
      throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesIccidSmsrHttpAddressPost.');
    }
    if (smsrAddressObject === null || smsrAddressObject === undefined) {
      throw new Error('Required parameter smsrAddressObject was null or undefined when calling cardsEidProfilesIccidSmsrHttpAddressPost.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles/${encodeURIComponent(String(iccid))}/smsr_http_address`,
      smsrAddressObject,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Enable or disable the selected profile
   * @param eid EID of a requested card
   * @param iccid ICCID of a target profile
   * @param enable True for enabling the profile, false for disabling
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidProfilesPost(eid: string, iccid: string, enable: boolean, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidProfilesPost(eid: string, iccid: string, enable: boolean, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidProfilesPost(eid: string, iccid: string, enable: boolean, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidProfilesPost(eid: string, iccid: string, enable: boolean, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesPost.');
    }
    if (iccid === null || iccid === undefined) {
      throw new Error('Required parameter iccid was null or undefined when calling cardsEidProfilesPost.');
    }
    if (enable === null || enable === undefined) {
      throw new Error('Required parameter enable was null or undefined when calling cardsEidProfilesPost.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (iccid !== undefined) {
      queryParameters = queryParameters.set('iccid', <any>iccid);
    }
    if (enable !== undefined) {
      queryParameters = queryParameters.set('enable', <any>enable);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.post<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles`,
      null,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Download a profile to the card
   * @param eid EID of a requested card
   * @param poolId profile pool to take a profile from
   * @param activate Set to true if the profile should be activated after download
   * @param iccid Iccid of the profile to select
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidProfilesPut(eid: string, poolId: string, activate?: boolean, iccid?: string, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidProfilesPut(eid: string, poolId: string, activate?: boolean, iccid?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidProfilesPut(eid: string, poolId: string, activate?: boolean, iccid?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidProfilesPut(eid: string, poolId: string, activate?: boolean, iccid?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidProfilesPut.');
    }
    if (poolId === null || poolId === undefined) {
      throw new Error('Required parameter poolId was null or undefined when calling cardsEidProfilesPut.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (poolId !== undefined) {
      queryParameters = queryParameters.set('pool_id', <any>poolId);
    }
    if (activate !== undefined) {
      queryParameters = queryParameters.set('activate', <any>activate);
    }
    if (iccid !== undefined) {
      queryParameters = queryParameters.set('iccid', <any>iccid);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.put<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/profiles`,
      null,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get information about list of transactions or single transaction
   * @param eid EID of the requested card
   * @param transactionId ID of the requested transaction
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidTransactionsGet(eid: string, transactionId?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<TRANSACTIONINFO>>;
  public cardsEidTransactionsGet(eid: string, transactionId?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<TRANSACTIONINFO>>>;
  public cardsEidTransactionsGet(eid: string, transactionId?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<TRANSACTIONINFO>>>;
  public cardsEidTransactionsGet(eid: string, transactionId?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidTransactionsGet.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (transactionId !== undefined) {
      queryParameters = queryParameters.set('transaction_id', <any>transactionId);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<TRANSACTIONINFO>>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/transactions`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Transaction state getting operation
   * @param eid EID of the requested card
   * @param transactionId ID of the requested transaction
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidTransactionsTransactionIdGet(eid: string, transactionId: number, observe?: 'body', reportProgress?: boolean): Observable<TRANSACTIONINFO>;
  public cardsEidTransactionsTransactionIdGet(eid: string, transactionId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TRANSACTIONINFO>>;
  public cardsEidTransactionsTransactionIdGet(eid: string, transactionId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TRANSACTIONINFO>>;
  public cardsEidTransactionsTransactionIdGet(eid: string, transactionId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (eid === null || eid === undefined) {
      throw new Error('Required parameter eid was null or undefined when calling cardsEidTransactionsTransactionIdGet.');
    }
    if (transactionId === null || transactionId === undefined) {
      throw new Error('Required parameter transactionId was null or undefined when calling cardsEidTransactionsTransactionIdGet.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<TRANSACTIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/transactions/${encodeURIComponent(String(transactionId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Card list getting operation. This is the operation to get a list of cards managed by the authenticated account
   * @param offset An offset for a list (required for pagination)
   * @param limit A maximum number of entries returned by the request
   * @param searchString Search for cards with given EID, ICCID, MSISDN or IMEI
   * @param cardGroupId Filter records by present group Id
   * @param poolId Filter records by present pool Id
   * @param mnoId Filter records by present mno Id
   * @param numberOfSubscriptions Filter records by the number of subscriptions present
   * @param status Filter record by status of the card
   * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - imsi,  - iccid,  - msisdn,  - mno_id,  - group_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<CARDINFO>>;
  public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<CARDINFO>>>;
  public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<CARDINFO>>>;
  public cardsGet(offset?: number, limit?: number, searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, status?: Array<string>, sortString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }
    if (searchString !== undefined) {
      queryParameters = queryParameters.set('search_string', <any>searchString);
    }
    if (cardGroupId) {
      cardGroupId.forEach((element) => {
        queryParameters = queryParameters.append('card_group_id', <any>element);
      })
    }
    if (poolId) {
      poolId.forEach((element) => {
        queryParameters = queryParameters.append('pool_id', <any>element);
      })
    }
    if (mnoId) {
      mnoId.forEach((element) => {
        queryParameters = queryParameters.append('mno_id', <any>element);
      })
    }
    if (numberOfSubscriptions) {
      numberOfSubscriptions.forEach((element) => {
        queryParameters = queryParameters.append('number_of_subscriptions', <any>element);
      })
    }
    if (status) {
      status.forEach((element) => {
        queryParameters = queryParameters.append('status', <any>element);
      })
    }
    if (sortString !== undefined) {
      queryParameters = queryParameters.set('sort_string', <any>sortString);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<CARDINFO>>(`${this.basePath}/cards`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Number of cards getting operation. This is the operation to get a number of cards managed by the authenticated account
   * @param searchString Search for cards with given EID, ICCID, MSISDN or IMEI
   * @param cardGroupId Filter records by present group Id
   * @param poolId Filter records by present pool Id
   * @param mnoId Filter records by present mno Id
   * @param numberOfSubscriptions Filter records by the number of subscriptions present
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsHead(searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public cardsHead(searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public cardsHead(searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public cardsHead(searchString?: string, cardGroupId?: Array<string>, poolId?: Array<string>, mnoId?: Array<string>, numberOfSubscriptions?: Array<number>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (searchString !== undefined) {
      queryParameters = queryParameters.set('search_string', <any>searchString);
    }
    if (cardGroupId) {
      cardGroupId.forEach((element) => {
        queryParameters = queryParameters.append('card_group_id', <any>element);
      })
    }
    if (poolId) {
      poolId.forEach((element) => {
        queryParameters = queryParameters.append('pool_id', <any>element);
      })
    }
    if (mnoId) {
      mnoId.forEach((element) => {
        queryParameters = queryParameters.append('mno_id', <any>element);
      })
    }
    if (numberOfSubscriptions) {
      numberOfSubscriptions.forEach((element) => {
        queryParameters = queryParameters.append('number_of_subscriptions', <any>element);
      })
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.head<any>(`${this.basePath}/cards`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }



  /**
   *
   * Get detailed information on the last operation with the card
   * @param eid EID of a requested card
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cardsEidStatusGet(eid: string, observe?: 'body', reportProgress?: boolean): Observable<APIOPERATIONINFO>;
  public cardsEidStatusGet(eid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<APIOPERATIONINFO>>;
  public cardsEidStatusGet(eid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<APIOPERATIONINFO>>;
  public cardsEidStatusGet(eid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
      if (eid === null || eid === undefined) {
          throw new Error('Required parameter eid was null or undefined when calling cardsEidStatusGet.');
      }

      let headers = this.defaultHeaders;

      // authentication (basicAuth) required
      if (this.configuration.username || this.configuration.password) {
          headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
      }

      // to determine the Accept header
      let httpHeaderAccepts: string[] = [
          'application/json'
      ];
      let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      if (httpHeaderAcceptSelected != undefined) {
          headers = headers.set("Accept", httpHeaderAcceptSelected);
      }

      // to determine the Content-Type header
      let consumes: string[] = [
      ];

      return this.httpClient.get<APIOPERATIONINFO>(`${this.basePath}/cards/${encodeURIComponent(String(eid))}/status`,
          {
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
  }

  /**
   *
   * List of pools getting operation. This is the operation to get a list of pools managed by the authenticated account
   * @param offset An offset for a list (required for pagination)
   * @param limit A maximum number of entries returned by the request
   * @param poolId Filter records by pool ids
   * @param poolName Filter records by pool names
   * @param country Filter records by country
   * @param mnoId Filter records by MNO ID
   * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - pool_id,  - pool_name,  - country,  - mno_id
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<POOLINFO>>;
  public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<POOLINFO>>>;
  public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<POOLINFO>>>;
  public poolsGet(offset?: number, limit?: number, poolId?: Array<number>, poolName?: Array<string>, country?: Array<string>, mnoId?: Array<string>, sortString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }
    if (poolId) {
      poolId.forEach((element) => {
        queryParameters = queryParameters.append('pool_id', <any>element);
      })
    }
    if (poolName) {
      poolName.forEach((element) => {
        queryParameters = queryParameters.append('pool_name', <any>element);
      })
    }
    if (country) {
      country.forEach((element) => {
        queryParameters = queryParameters.append('country', <any>element);
      })
    }
    if (mnoId) {
      mnoId.forEach((element) => {
        queryParameters = queryParameters.append('mno_id', <any>element);
      })
    }
    if (sortString !== undefined) {
      queryParameters = queryParameters.set('sort_string', <any>sortString);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<POOLINFO>>(`${this.basePath}/pools`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Number of pools getting operation. This is the operation to get a number of pools managed by the authenticated account
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsHead(observe?: 'body', reportProgress?: boolean): Observable<any>;
  public poolsHead(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public poolsHead(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public poolsHead(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.head<any>(`${this.basePath}/pools`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get detailed information about the pool
   * @param poolId Id of requested pool
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsPoolIdGet(poolId: number, observe?: 'body', reportProgress?: boolean): Observable<POOLINFO>;
  public poolsPoolIdGet(poolId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POOLINFO>>;
  public poolsPoolIdGet(poolId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POOLINFO>>;
  public poolsPoolIdGet(poolId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (poolId === null || poolId === undefined) {
      throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdGet.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<POOLINFO>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Update subset of pool information
   * @param poolId Id of requested pool
   * @param poolObjectSubset
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsPoolIdPost(poolId: number, poolObjectSubset: PoolObjectSubset, observe?: 'body', reportProgress?: boolean): Observable<POOLINFO>;
  public poolsPoolIdPost(poolId: number, poolObjectSubset: PoolObjectSubset, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POOLINFO>>;
  public poolsPoolIdPost(poolId: number, poolObjectSubset: PoolObjectSubset, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POOLINFO>>;
  public poolsPoolIdPost(poolId: number, poolObjectSubset: PoolObjectSubset, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (poolId === null || poolId === undefined) {
      throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdPost.');
    }
    if (poolObjectSubset === null || poolObjectSubset === undefined) {
      throw new Error('Required parameter poolObjectSubset was null or undefined when calling poolsPoolIdPost.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.post<POOLINFO>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}`,
      poolObjectSubset,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get a list of profiles from a specified pool
   * @param poolId Id of requested pool
   * @param status Filter for status of profiles
   * @param searchString String to search for cards with specific iccid or msisdn or imsi in the pool. Sort order from old records to new ones
   * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - pool_id,  - viccid,  - iccid,  - imsi  - msisdn  - status
   * @param offset An offset for a list (required for pagination)
   * @param limit A maximum number of entries returned by the request
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsPoolIdProfilesGet(poolId: number, status?: string, searchString?: string, sortString?: string, offset?: number, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<SMDPPROFILE>>;
  public poolsPoolIdProfilesGet(poolId: number, status?: string, searchString?: string, sortString?: string, offset?: number, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SMDPPROFILE>>>;
  public poolsPoolIdProfilesGet(poolId: number, status?: string, searchString?: string, sortString?: string, offset?: number, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SMDPPROFILE>>>;
  public poolsPoolIdProfilesGet(poolId: number, status?: string, searchString?: string, sortString?: string, offset?: number, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (poolId === null || poolId === undefined) {
      throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdProfilesGet.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (status !== undefined) {
      queryParameters = queryParameters.set('status', <any>status);
    }
    if (searchString !== undefined) {
      queryParameters = queryParameters.set('search_string', <any>searchString);
    }
    if (sortString !== undefined) {
      queryParameters = queryParameters.set('sort_string', <any>sortString);
    }
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<SMDPPROFILE>>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}/profiles`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Number of profiles getting operation. This is the operation to get a number of profiles contained in the pool
   * @param poolId Id of requested pool
   * @param searchString String to search for cards with specific iccid or msisdn or imsi in the pool
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsPoolIdProfilesHead(poolId: number, searchString?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public poolsPoolIdProfilesHead(poolId: number, searchString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public poolsPoolIdProfilesHead(poolId: number, searchString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public poolsPoolIdProfilesHead(poolId: number, searchString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (poolId === null || poolId === undefined) {
      throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdProfilesHead.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (searchString !== undefined) {
      queryParameters = queryParameters.set('search_string', <any>searchString);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.head<any>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}/profiles`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Move subscriptions to the selected pool
   * @param poolId ID of the target subscription pool
   * @param iccids The list containing ICCID of subscriptions to be moved to the target card group
   * @param sourceId ID of the source subscription pool containing subscriptions to be moved
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsPoolIdProfilesPut(poolId: number, iccids: Array<string>, sourceId: number, observe?: 'body', reportProgress?: boolean): Observable<Array<RESPONSEITEM>>;
  public poolsPoolIdProfilesPut(poolId: number, iccids: Array<string>, sourceId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<RESPONSEITEM>>>;
  public poolsPoolIdProfilesPut(poolId: number, iccids: Array<string>, sourceId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<RESPONSEITEM>>>;
  public poolsPoolIdProfilesPut(poolId: number, iccids: Array<string>, sourceId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
      if (poolId === null || poolId === undefined) {
          throw new Error('Required parameter poolId was null or undefined when calling poolsPoolIdProfilesPut.');
      }
      if (iccids === null || iccids === undefined) {
          throw new Error('Required parameter iccids was null or undefined when calling poolsPoolIdProfilesPut.');
      }
      if (sourceId === null || sourceId === undefined) {
          throw new Error('Required parameter sourceId was null or undefined when calling poolsPoolIdProfilesPut.');
      }

      let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
      if (sourceId !== undefined) {
          queryParameters = queryParameters.set('source_id', <any>sourceId);
      }

      let headers = this.defaultHeaders;

      // authentication (basicAuth) required
      if (this.configuration.username || this.configuration.password) {
          headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
      }

      // to determine the Accept header
      let httpHeaderAccepts: string[] = [
          'application/json'
      ];
      let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
      if (httpHeaderAcceptSelected != undefined) {
          headers = headers.set("Accept", httpHeaderAcceptSelected);
      }

      // to determine the Content-Type header
      let consumes: string[] = [
      ];
      let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
      if (httpContentTypeSelected != undefined) {
          headers = headers.set("Content-Type", httpContentTypeSelected);
      }

      return this.httpClient.put<Array<RESPONSEITEM>>(`${this.basePath}/pools/${encodeURIComponent(String(poolId))}/profiles`,
          iccids,
          {
              params: queryParameters,
              withCredentials: this.configuration.withCredentials,
              headers: headers,
              observe: observe,
              reportProgress: reportProgress
          }
      );
  }

  /**
   *
   * Register new pool in the database. Account should be granted with special permissions for this procedure
   * @param poolObject
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public poolsPut(poolObject: POOLINFO, observe?: 'body', reportProgress?: boolean): Observable<POOLINFO>;
  public poolsPut(poolObject: POOLINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<POOLINFO>>;
  public poolsPut(poolObject: POOLINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<POOLINFO>>;
  public poolsPut(poolObject: POOLINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (poolObject === null || poolObject === undefined) {
      throw new Error('Required parameter poolObject was null or undefined when calling poolsPut.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.put<POOLINFO>(`${this.basePath}/pools`,
      poolObject,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * List all users
   * @param offset An offset for a list (required for pagination)
   * @param limit A maximum number of entries returned by the request
   * @param searchString String to search for users in fields userId, firstName, lastName, email and phone
   * @param sortString The string that defines the sorting. It has the following form XYYYYYY, XYYYYYYY. X - sort order. if x - &#39;-&#39; then descending, if x - &#39;+&#39;, then ascending. Y - name of the field by which the records are sorted. Available values for Y  - userid,  - firstname,  - lastname,  - email,  - phone
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersGet(offset?: number, limit?: number, searchString?: string, sortString?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<USERINFO>>;
  public usersGet(offset?: number, limit?: number, searchString?: string, sortString?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<USERINFO>>>;
  public usersGet(offset?: number, limit?: number, searchString?: string, sortString?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<USERINFO>>>;
  public usersGet(offset?: number, limit?: number, searchString?: string, sortString?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (offset !== undefined) {
      queryParameters = queryParameters.set('offset', <any>offset);
    }
    if (limit !== undefined) {
      queryParameters = queryParameters.set('limit', <any>limit);
    }
    if (searchString !== undefined) {
      queryParameters = queryParameters.set('search_string', <any>searchString);
    }
    if (sortString !== undefined) {
      queryParameters = queryParameters.set('sort_string', <any>sortString);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<USERINFO>>(`${this.basePath}/users`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Number of users getting operation. This is the operation to get a number of card groups managed by the authenticated account
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersHead(observe?: 'body', reportProgress?: boolean): Observable<any>;
  public usersHead(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public usersHead(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public usersHead(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.head<any>(`${this.basePath}/users`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Create a new user
   * @param userInfo User information
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersPut(userInfo: USERINFO, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public usersPut(userInfo: USERINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public usersPut(userInfo: USERINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public usersPut(userInfo: USERINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (userInfo === null || userInfo === undefined) {
      throw new Error('Required parameter userInfo was null or undefined when calling usersPut.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.put<any>(`${this.basePath}/users`,
      userInfo,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Delete a user
   * @param userId User ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersUserIdDelete(userId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public usersUserIdDelete(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public usersUserIdDelete(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public usersUserIdDelete(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling usersUserIdDelete.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.delete<any>(`${this.basePath}/users/${encodeURIComponent(String(userId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get user by ID
   * @param userId User ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersUserIdGet(userId: string, observe?: 'body', reportProgress?: boolean): Observable<USERINFO>;
  public usersUserIdGet(userId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<USERINFO>>;
  public usersUserIdGet(userId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<USERINFO>>;
  public usersUserIdGet(userId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling usersUserIdGet.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<USERINFO>(`${this.basePath}/users/${encodeURIComponent(String(userId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Remove the permissions for user
   * @param userId User ID
   * @param objectType Type of object
   * @param objectId ID of object
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersUserIdPermissionsDelete(userId: string, objectType: string, objectId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public usersUserIdPermissionsDelete(userId: string, objectType: string, objectId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public usersUserIdPermissionsDelete(userId: string, objectType: string, objectId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public usersUserIdPermissionsDelete(userId: string, objectType: string, objectId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling usersUserIdPermissionsDelete.');
    }
    if (objectType === null || objectType === undefined) {
      throw new Error('Required parameter objectType was null or undefined when calling usersUserIdPermissionsDelete.');
    }
    if (objectId === null || objectId === undefined) {
      throw new Error('Required parameter objectId was null or undefined when calling usersUserIdPermissionsDelete.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (objectType !== undefined) {
      queryParameters = queryParameters.set('object_type', <any>objectType);
    }
    if (objectId !== undefined) {
      queryParameters = queryParameters.set('object_id', <any>objectId);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.delete<any>(`${this.basePath}/users/${encodeURIComponent(String(userId))}/permissions`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Get the permissions for user
   * @param userId User ID
   * @param objectType Filter for object type
   * @param objectId Filter for object ID
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersUserIdPermissionsGet(userId: string, objectType?: string, objectId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ACLINFO>>;
  public usersUserIdPermissionsGet(userId: string, objectType?: string, objectId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ACLINFO>>>;
  public usersUserIdPermissionsGet(userId: string, objectType?: string, objectId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ACLINFO>>>;
  public usersUserIdPermissionsGet(userId: string, objectType?: string, objectId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling usersUserIdPermissionsGet.');
    }

    let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
    if (objectType !== undefined) {
      queryParameters = queryParameters.set('object_type', <any>objectType);
    }
    if (objectId !== undefined) {
      queryParameters = queryParameters.set('object_id', <any>objectId);
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];

    return this.httpClient.get<Array<ACLINFO>>(`${this.basePath}/users/${encodeURIComponent(String(userId))}/permissions`,
      {
        params: queryParameters,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Update the permissions for user
   * @param userId User ID
   * @param aclInfo
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersUserIdPermissionsPost(userId: string, aclInfo: ACLINFO, observe?: 'body', reportProgress?: boolean): Observable<ACLINFO>;
  public usersUserIdPermissionsPost(userId: string, aclInfo: ACLINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ACLINFO>>;
  public usersUserIdPermissionsPost(userId: string, aclInfo: ACLINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ACLINFO>>;
  public usersUserIdPermissionsPost(userId: string, aclInfo: ACLINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling usersUserIdPermissionsPost.');
    }
    if (aclInfo === null || aclInfo === undefined) {
      throw new Error('Required parameter aclInfo was null or undefined when calling usersUserIdPermissionsPost.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.post<ACLINFO>(`${this.basePath}/users/${encodeURIComponent(String(userId))}/permissions`,
      aclInfo,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Create new permission for user
   * @param userId User ID
   * @param aclInfo
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersUserIdPermissionsPut(userId: string, aclInfo: ACLINFO, observe?: 'body', reportProgress?: boolean): Observable<ACLINFO>;
  public usersUserIdPermissionsPut(userId: string, aclInfo: ACLINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ACLINFO>>;
  public usersUserIdPermissionsPut(userId: string, aclInfo: ACLINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ACLINFO>>;
  public usersUserIdPermissionsPut(userId: string, aclInfo: ACLINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling usersUserIdPermissionsPut.');
    }
    if (aclInfo === null || aclInfo === undefined) {
      throw new Error('Required parameter aclInfo was null or undefined when calling usersUserIdPermissionsPut.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.put<ACLINFO>(`${this.basePath}/users/${encodeURIComponent(String(userId))}/permissions`,
      aclInfo,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   * Update the user info
   * @param userId User ID
   * @param userInfo
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public usersUserIdPost(userId: string, userInfo: USERINFO, observe?: 'body', reportProgress?: boolean): Observable<USERINFO>;
  public usersUserIdPost(userId: string, userInfo: USERINFO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<USERINFO>>;
  public usersUserIdPost(userId: string, userInfo: USERINFO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<USERINFO>>;
  public usersUserIdPost(userId: string, userInfo: USERINFO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
    if (userId === null || userId === undefined) {
      throw new Error('Required parameter userId was null or undefined when calling usersUserIdPost.');
    }
    if (userInfo === null || userInfo === undefined) {
      throw new Error('Required parameter userInfo was null or undefined when calling usersUserIdPost.');
    }

    let headers = this.defaultHeaders;

    // authentication (basicAuth) required
    if (this.configuration.username || this.configuration.password) {
      headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'application/json'
    ];
    let httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set("Accept", httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    let consumes: string[] = [
    ];
    let httpContentTypeSelected:string | undefined = this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set("Content-Type", httpContentTypeSelected);
    }

    return this.httpClient.post<USERINFO>(`${this.basePath}/users/${encodeURIComponent(String(userId))}`,
      userInfo,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
 }



// WEBPACK FOOTER //
// ./src/gen/swagger-api/api/default.service.ts